"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileViewOptions = void 0;
const React = require("react");
const material_1 = require("@mui/material");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "MobileViewOptions");
const MobileViewOptions = ({ viewOption, setViewOption }) => {
    const viewOptions = ["list", "map"];
    const handleChange = (_event, newValue) => {
        setViewOption(newValue);
    };
    return (React.createElement("div", { className: css("") },
        React.createElement(material_1.Tabs, { value: viewOption, onChange: handleChange },
            React.createElement(material_1.Tab, { label: viewOptions[0], key: viewOptions[0], onClick: () => {
                    setViewOption(0);
                } }),
            React.createElement(material_1.Tab, { label: viewOptions[1], key: viewOptions[1], onClick: () => {
                    setViewOption(1);
                } }),
            "))")));
};
exports.MobileViewOptions = MobileViewOptions;
//# sourceMappingURL=index.js.map